import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { PanelStackComponent } from './panel-stack.component';

@NgModule({
    imports: [CommonModule, TwcModule, TranslateModule],
    declarations: [PanelStackComponent],
    exports: [PanelStackComponent],
})
export class PanelStackModule {}
